<template>
  <div class="submit-button">
    <div v-if="!isNewsForm" class="rol1" :style="{justifyContent: showRule ? 'space-between' : 'flex-end'}">
      <span class="rules" v-if="showRule">请阅读<router-link class="link" :to="'/rules'">《活动规则》</router-link>后提交</span>
      <van-button class="my-button" type="primary" :disabled="disabled" @click="handleClick" :loading="loading" loading-text="提交中...">{{buttonText}}</van-button>
    </div>
    <div class="rol2" v-if="!isNewsForm">
      标记*为必填项。<span class="tips" v-if="companyOnly">试用仅限企业用户。</span><br>
      <span>{{tips}}</span>
    </div>
    <van-button v-if="isNewsForm" class="my-button newsBtn" type="primary" :disabled="disabled" @click="handleClick" :loading="loading" loading-text="提交中...">{{buttonText}}</van-button>
  </div>
</template>

<script>
export default {
  name: 'SubmitButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    showRule: {
      type: Boolean,
      default: true
    },
    companyOnly: {
      type: Boolean,
      default: true
    },
    tips: {
      type: String,
      default: '为不影响您获得体验的机会，请务必准确填写并核对信息，我们将通过电话和短信的方式与您联系。'
    },
    buttonText: {
      type: String,
      default: '已阅读并提交'
    },
    isNewsForm: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick () {
      this.$emit('click');
    }
  }
}
</script>

<style lang="scss" scoped>
@import './SubmitButton.scss';
</style>